import { __styles } from '@fluentui/react-components';
export const useItemLayoutStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f13qh94s",
    Budl1dq: "f10xlqro",
    sshi5w: "f1e8ugpm"
  },
  contentMedia: {
    qb2dma: "f9h729m",
    Br312pm: "fis13di",
    Bw0ie65: "fsyjsko",
    Ijaq50: "faunodf",
    nk6f5a: "fcu02xx",
    Be2twd7: "f1ugzwwg",
    Bg96gwp: "f16tcgob"
  },
  contentWrapper: {
    qb2dma: "f9h729m",
    Br312pm: "fd46tj4",
    Bw0ie65: "fz1yyy6",
    Ijaq50: "faunodf",
    nk6f5a: "fcu02xx",
    t21cq0: ["f1phki43", "ff9s3yw"],
    Be2twd7: "f1ugzwwg",
    Bg96gwp: "f16tcgob"
  },
  header: {
    qb2dma: "f1locze1",
    Br312pm: "fd46tj4",
    Bw0ie65: "fz1yyy6",
    Ijaq50: "f16hsg94",
    nk6f5a: "f88nxoq",
    Be2twd7: "fses1vf",
    t21cq0: ["f1phki43", "ff9s3yw"]
  },
  headerMedia: {
    qb2dma: "f1locze1",
    Br312pm: "fis13di",
    Bw0ie65: "fsyjsko",
    Ijaq50: "f16hsg94",
    nk6f5a: "f88nxoq",
    Be2twd7: "f1ugzwwg",
    Bg96gwp: "f16tcgob"
  },
  startMedia: {
    qb2dma: "f7nlbp4",
    Br312pm: "fwpfdsa",
    Bw0ie65: "f1e2fz10",
    Ijaq50: "f16hsg94",
    nk6f5a: "fcu02xx",
    t21cq0: ["f1phki43", "ff9s3yw"]
  },
  endMedia: {
    qb2dma: "f7nlbp4",
    Br312pm: "f1f195pj",
    Bw0ie65: "f1u8tn6t",
    Ijaq50: "f16hsg94",
    nk6f5a: "fcu02xx"
  }
}, {
  d: [".f13qh94s{display:grid;}", ".f10xlqro{grid-template-columns:auto 1fr auto auto;}", ".f1e8ugpm{min-height:48px;}", ".f9h729m{align-self:start;}", ".fis13di{grid-column-start:3;}", ".fsyjsko{grid-column-end:4;}", ".faunodf{grid-row-start:2;}", ".fcu02xx{grid-row-end:3;}", ".f1ugzwwg{font-size:12px;}", ".f16tcgob{line-height:1.3333;}", ".fd46tj4{grid-column-start:2;}", ".fz1yyy6{grid-column-end:3;}", ".f1phki43{margin-right:8px;}", ".ff9s3yw{margin-left:8px;}", ".f1locze1{align-self:end;}", ".f16hsg94{grid-row-start:1;}", ".f88nxoq{grid-row-end:2;}", ".fses1vf{font-size:14px;}", ".f7nlbp4{align-self:center;}", ".fwpfdsa{grid-column-start:1;}", ".f1e2fz10{grid-column-end:2;}", ".f1f195pj{grid-column-start:4;}", ".f1u8tn6t{grid-column-end:5;}"]
});
//# sourceMappingURL=ItemLayout.styles.js.map